import { View } from "react-native";
import { Text } from "@shared/components/text";

export type TReadingTagTone = 'neutral' | 'ok' | 'warn';

const TONE_STYLES: Record<TReadingTagTone, string> = {
    neutral: "bg-gray-200 border-gray-300",
    ok: "bg-success-100 border-success-100",
    warn: "bg-warning-100 border-warning-100",
};

const TONE_TEXT_STYLES: Record<TReadingTagTone, string> = {
    neutral: "text-gray-500",
    ok: "text-success-500",
    warn: "text-warning-700",
};

export const ReadingTag = ({ label, tone = 'neutral' }: { label: string; tone?: TReadingTagTone }) => (
    <View className={`self-start rounded-full border px-4 py-[7px] min-w-[96px] ${TONE_STYLES[tone]}`}>
        <Text className={`text-sm font-semibold text-center ${TONE_TEXT_STYLES[tone]}`} numberOfLines={1}>{label}</Text>
    </View>
);

export default ReadingTag;
